import { IQueueRowSignals } from "./queueRowSignals";

export interface IDrawerSectionDone {
  grade: boolean;
  title: boolean;
  price: boolean;
  health: boolean;
}

export interface IDrawerSectionInputs {
  signals: IQueueRowSignals;
  grade: string | null | undefined;
  stagedTitle: string | null;
  stagedPrice: number | null;
}

/** Tailwind for a drawer section that is done - the light green wash that says "nothing left here". */
export const DONE_SECTION_CLASSES = "border-green-200 bg-green-50";

/**
 * Which drawer sections are finished for this listing, so each can turn green as the operator works
 * down the drawer. Grade: one is set. Title: a new title is staged. Price: a new price is staged, or
 * the live price already sits within 10% of the market. Listing health: nothing fixable is missing and
 * nothing blocks the relist.
 */
export function drawerSectionDone({ signals, grade, stagedTitle, stagedPrice }: IDrawerSectionInputs): IDrawerSectionDone {
  return {
    grade: (grade ?? "").trim().length > 0,
    title: stagedTitle != null && stagedTitle.trim().length > 0,
    price: (stagedPrice != null && stagedPrice > 0) || signals.delta.tone === "within",
    health: !signals.relistBlocked && signals.score.missing.length === 0,
  };
}
